import React from "react"
import classNames from "classnames"

import OutboundLink from "./outbound-link"

import VotableComponent from "./votable-component"
import StarRating from "./star-rating"
import WinnerCupImage from "../../static/images/winner.svg"

let ticking = false;

class Answer extends VotableComponent {
  ticking = false

  constructor(props) {
    super(props)
    this.checkPriceButton = React.createRef();
    this.state.showVotingBar = false
  }

  componentDidMount() {
    this.shouldStickBar()
  }

  shouldStickBar = () => {
    const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    if (vw < 730) {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame( () =>  {
        this.shouldShowVotingBar()
        ticking = false
      });
      ticking = true
    }
  }

  shouldShowVotingBar = () => {
    const { showVotingBar } = this.state
    let offset = this.checkPriceButton.current.getBoundingClientRect()

    if (offset.top < 0 && !showVotingBar) {
      this.setState({
        showVotingBar: true
      })
    }

    if (offset.top > 0 && showVotingBar) {
      this.setState({
        showVotingBar: false
      })
    }
  }

  render() {
    const { data, isWinner, html, siteUrl } = this.props
    const votingBarClassName = classNames("voting-bar", {
      hidden: !this.state.showVotingBar
    })

    return (
      <React.Fragment>
        <article className="answer hidden-tablet" id={ isWinner ? "most-voted" : ''}>
          <h2>
            <img
              src={WinnerCupImage}
              alt=""
            />
            <OutboundLink href={data.productLink} target={!isWinner ? "_blank" : null }>
              #{data.position} {data.title}
            </OutboundLink>
          </h2>

          <div className="product">
            <OutboundLink href={data.productLink} target={!isWinner ? "_blank" : null }>
              <img
                src={`${siteUrl}/${data.productImage}`}
                alt=""
              />
            </OutboundLink> 
            <StarRating stars={ data.stars } />
            <div ref={ this.checkPriceButton }></div>
            <OutboundLink className="button check-price" href={data.productLink} target={!isWinner ? "_blank" : null }>
              Check price on Amazon
            </OutboundLink> 
          </div>

          <div className="highlights">
            <h3>Discussion highlights:</h3>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>

          <div className="votes">
            <div className="counter most-voted horizontal">
              <button
                className="button voting vote-up arrow"
                onClick={ this.onLike }>
              </button>
              <span>{ this.state.currentLikes }</span>
              <button
                className="button voting vote-down arrow"
                onClick={ this.onDislike }>
              </button>
            </div>
            <div className="users">
              { data.usersAvatars.map( (user, index) => (
                <div className="avatar small" key={`avatar-${index}`}>
                  <img src={`${siteUrl}/${user.avatar }`} alt="" />
                </div>
              ))}
              <span> ...</span>
            </div>
          </div>
        </article>
        <article className="answer horizontal hidden-mobile" id={ isWinner ? "most-voted" : ''}>
          <h2>
          <img
              src={WinnerCupImage}
              alt=""
            />
            <OutboundLink href={data.productLink} target={!isWinner ? "_blank" : null }>
              #{data.position} {data.title}
            </OutboundLink> 
          </h2>

          <div className="wrapper">
            <div className="votes">
              <div className="counter most-voted">
                <button
                  className="button voting vote-up arrow"
                  onClick={ this.onLike }>
                </button>
                <span>{ this.state.currentLikes }</span>
                <button
                  className="button voting vote-down arrow"
                  onClick={ this.onDislike }>
                </button>
              </div>
            </div>

            <OutboundLink href={data.productLink} target={!isWinner ? "_blank" : null }>
              <div className="product">
                <img
                  src={`${siteUrl}/${data.productImage}`}
                  alt=""
                />
                <StarRating stars={ data.stars } />
              </div>
            </OutboundLink> 

            <div className="details">
              <div className="votes">
                <div className="users">
                  { data.usersAvatars.map( (user, index) => (
                    <div className="avatar small" key={`avatar-${index}`}>
                      <img src={`${siteUrl}/${user.avatar}`} alt="" />
                    </div>
                  ))}
                  <span> ...</span>
                </div>
              </div>

              <div className="highlights">
                <h3>Discussion highlights:</h3>
                <div dangerouslySetInnerHTML={{ __html: html }} />
              </div>

              <OutboundLink className="button check-price" href={data.productLink} target={!isWinner ? "_blank" : null }>
                Check price on Amazon
              </OutboundLink> 
            </div>
          </div>
        </article>
        <div className={ votingBarClassName } id="voting-bar">
          <OutboundLink href={data.productLink}>
            <img
              src={`${siteUrl}/${data.productImage}`}
              alt={`#1 ${data.title}`}
            />
            <h2>
              <span>The Winner</span>
              {data.title}
            </h2>
            <button className="button check-price small">
              Check Price
            </button>
          </OutboundLink> 
        </div>
      </React.Fragment>
    )
  }
}

export default Answer
